


const firebaseConfig = {
  apiKey: "AIzaSyB--CVOoaghY2Wa2M605j4OEXMVXpbaIWs",
  authDomain: "onlineshop-269c3.firebaseapp.com",
  projectId: "onlineshop-269c3",
  storageBucket: "onlineshop-269c3.appspot.com",
  messagingSenderId: "177266283624",
  appId: "1:177266283624:web:ec41b81e1807cc583597dd",
  measurementId: "G-JZGNG0TZPG"
};
// const firebaseConfig = {


// //   apiKey: process.env.REACT_APP_APIKEY,
// //   authDomain: process.env.REACT_APP_AUTHDOMAIN,
// //   projectId: process.env.REACT_APP_PROJECTID,
// //   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
// //   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
// //   appId: process.env.REACT_APP_APPID,
// //   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

export default firebaseConfig;

// Initialize Firebase
